var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 832 292",
    style: {
      enableBackground: "new 0 0 832 292"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCB813;}\n\t.st1{fill:#0066B2;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#C3161C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M126.4,37.5c-32.3,17.8-67.2,48.6-78,94.7c-12.2,52.1,10,87.2,53.9,119.1l-18.6-10.1 c-41-21.8-62.9-49.1-62.7-98.9c0.2-67.4,84.1-130,142.1-125C138.6,18.3,126.4,37.5,126.4,37.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st1",
    d: "M120.4,78.1c-103.7,85.4-4.5,181.4-4.5,181.4c-29.9-17-53-38.3-63.9-65.5 C30.5,140.9,61.3,71,126.4,37.5C112,55.8,120.4,78.1,120.4,78.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_45_",
    className: "st2",
    points: "62.5,124.1 65.4,126.7 69.2,125.8 67.5,129.3 69.5,132.6 65.7,132.2 63.1,135  62.3,131.3 58.7,129.8 62.1,127.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_44_",
    className: "st2",
    points: "70,103.4 74.1,105.4 78.2,103.2 77.5,107.7 80.9,110.9 76.3,111.6 74.3,115.7  72.1,111.7 67.5,111.1 70.8,107.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_43_",
    className: "st2",
    points: "78.6,90 82.9,87.1 82.9,82 87,85.1 92,83.6 90.3,88.3 93.3,92.4 88.1,92.3 85,96.4  83.6,91.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_42_",
    className: "st2",
    points: "94.9,72.4 100,69 100,63 104.9,66.7 110.8,65 108.6,70.6 112.2,75.5 106.1,75.3  102.4,80.1 100.7,74.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_41_",
    className: "st2",
    points: "61.4,145.7 62.5,148.8 65.7,149.8 62.9,151.7 63,155 60.3,153.1 57,154.2 58.1,151  56.1,148.3 59.5,148.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_40_",
    className: "st2",
    points: "57.6,167.2 60.3,169.1 63.5,168 62.5,171.1 64.6,173.7 61.2,173.7 59.4,176.4  58.3,173.3 55.1,172.4 57.8,170.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_39_",
    className: "st2",
    points: "62.6,188.8 64.7,190.7 67.5,190.1 66.3,192.7 67.8,195 64.9,194.7 63,196.8 62.5,194  59.8,192.9 62.4,191.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_38_",
    className: "st2",
    points: "70.8,206.5 72.3,208.6 74.8,208.7 73.1,210.6 73.8,213 71.5,212.1 69.4,213.4  69.5,211 67.5,209.4 70,208.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st3",
    d: "M135.9,100.1c-10.9,7.7-20.7,17.4-27.3,29.7c-36,67.6,24.8,139.3,24.8,139.3l-17.6-9.7 c0,0-70-56.1-32.5-138.2c8.8-19.2,19.2-31.6,37.1-43.2C125.9,94.3,135.9,100.1,135.9,100.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st3",
    d: "M198.6,64c0,15.1-12.6,27.4-28.1,27.4c-15.6,0-28.2-12.3-28.2-27.4c0-15.2,12.6-27.5,28.2-27.5 C186,36.5,198.6,48.9,198.6,64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st3",
    d: "M277,120.1c-21.2,0-39.3,7.4-54.4,22.1c-14.9,14.6-22.4,32.3-22.4,53v73.7h26.6v-73.7 c0-13.6,4.9-25.2,14.8-34.7c9.8-9.5,21.6-14.3,35.5-14.3c13.9,0,25.7,4.7,35.6,14.3c9.8,9.6,14.7,21.1,14.7,34.7v73.7h26.7v-73.7 c0-20.7-7.5-38.4-22.6-53C316.4,127.5,298.2,120.1,277,120.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st3",
    d: "M444,145.5c27.1-0.2,44.2,24,44.2,24l19.3-18.8l-9.5-9.2c-14.8-14.5-32.9-21.8-54-21.8 c-21.1,0-39,7.4-54,21.9c-15,14.6-22.4,32.2-22.4,52.8c0,20.4,7.5,38,22.4,52.6c15,14.7,32.9,22,54,22c21.1,0,39.2-7.3,54-22 l-18.6-18.1c-9.8,9.5-21.6,14.3-35.4,14.3c-13.8,0-25.5-4.8-35.3-14.3c-9.8-9.5-14.7-21-14.7-34.4c0-13.5,4.9-25.1,14.7-34.5 C418.4,150.3,430.1,145.5,444,145.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st3",
    d: "M583.5,118.7c-21.2,0-35.9,7.3-51,22c-15.1,14.7-22.6,32.4-22.6,53c0,20.7,7.5,38.4,22.6,53 c15.1,14.7,33.3,22.1,54.4,22.1c21.3,0,39.5-7.4,54.4-22.1l-18.8-18.3c-9.9,9.6-21.7,14.3-35.6,14.3c-11.4,0-21.6-3.4-30.7-10.2 c-8.8-6.8-14.8-15.4-17.9-25.9h120.4v-13c0-20.7-7.5-40-22.5-54.7C621.1,124.3,604.7,118.7,583.5,118.7 M538.3,180.8 c3.1-10.6,7.3-20.9,16.1-27.6c9.1-6.8,17.6-10.1,29.1-10.1c11.4,0,21.7,3.3,30.7,10.1c8.9,6.8,14.8,17,17.9,27.6H538.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st3",
    d: "M749.1,180.8h-11.8c-17.1,0-28.5-2.8-34.1-8.2c-2.4-2.4-3.6-5.6-3.6-9.7c0-3.4,1.2-6.2,3.5-8.5 c6.2-6,17.6-9,34.1-9c10.8,0.1,20.1,1.7,27.6,4.7c8.7,3.5,13,8.2,13,14h26.5c0-13.4-6.1-24.2-18.1-32.2 c-12.2-8-28.4-12.1-48.8-12.3c-24.3,0.4-41.9,5.8-52.9,16.5c-7.4,7.3-11.2,16.2-11.3,26.6c0,11.2,3.8,20.5,11.3,28 c10.9,10.5,28.6,15.8,53.5,15.8h10.4c17,0.5,28.4,2.6,34.2,6.7c3.3,2.3,5,5.5,5,9.7c0,8.1-6.9,13.8-20.8,17.1c-8.4,2-18.2,3-29.5,3 c-12.4,0-22.2-1.8-29.5-5.2c-9.7-4.6-14.5-12-14.5-22.3h-26.4c0,16.4,6.3,29.4,19,38.9c12.6,9.6,29.8,14.3,51.5,14.3 c30.1,0,51.5-5.9,64.4-17.7c8.2-7.7,12.3-17.1,12.3-28.2C814,196,792.4,181.9,749.1,180.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st3",
    d: "M183.8,111.8v157h-26.6v-157C157.1,111.8,169.2,118.1,183.8,111.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.4d14c4102408dceaa95be6a2fa8175e4.svg";
export { ForwardRef as ReactComponent };